import {cloneTemplate} from './WebComponents';

// JS mirror of --loading-indicator-delay in assets/scss/_theme.scss.
export const LOADING_INDICATOR_DELAY_MS = 500;

export const cloneSpinner = () => cloneTemplate('#spinner-template');

export const cloneButtonSpinner = () => cloneTemplate('#button-spinner-template');

export const toggleLoading = (element, isLoading) => element.classList.toggle('loading', isLoading);
